module.exports = __webpack_public_path__ + "img/loading.6442d6be.jpg";